var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { dense: "" } },
        [
          _c(
            "v-toolbar-side-icon",
            [
              _c(
                "v-icon",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.resetTimeTravel }
                },
                [_vm._v("skip_previous")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-toolbar-title", [_vm._v("Dispatcher Space-Time Continuum")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-toolbar",
        { staticClass: "mt-2", attrs: { flat: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-text-field",
                {
                  attrs: {
                    flat: "",
                    readonly: "",
                    "persistent-hint": "",
                    hint: "Starting Time",
                    "prepend-inner-icon": "access_alarms"
                  },
                  model: {
                    value: _vm.startingTimeDisplay,
                    callback: function($$v) {
                      _vm.startingTimeDisplay = $$v
                    },
                    expression: "startingTimeDisplay"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "append-outer" },
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/static/flux-capacitor.png",
                          height: "50",
                          width: "50"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "pl-2 centered-input",
                attrs: {
                  flat: "",
                  readonly: "",
                  "persistent-hint": "",
                  hint: "Future Time",
                  "append-icon": "watch"
                },
                model: {
                  value: _vm.currentFutureTimeDisplay,
                  callback: function($$v) {
                    _vm.currentFutureTimeDisplay = $$v
                  },
                  expression: "currentFutureTimeDisplay"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "div",
            { staticClass: "pb-3" },
            [
              _c(
                "GmapMap",
                {
                  ref: "mapRef",
                  style: _vm.styles,
                  attrs: {
                    center: _vm.mapCenter,
                    zoom: _vm.mapZoomLevel,
                    "map-type-id": "roadmap"
                  }
                },
                [
                  _c(
                    "gmap-info-window",
                    {
                      attrs: {
                        options: _vm.infoOptions,
                        position: _vm.infoWindowPos,
                        opened: _vm.infoWinOpen
                      },
                      on: {
                        closeclick: function($event) {
                          return _vm.closeClick()
                        }
                      }
                    },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.infoContent) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.bookedLoadPositionMarkers, function(
                    positionMarker,
                    idx
                  ) {
                    return _vm.bookedLoadPositionMarkers
                      ? _c("GmapMarker", {
                          key: "booked_load_markerId_" + idx,
                          attrs: {
                            position: {
                              lat: positionMarker.lat,
                              lng: positionMarker.lng
                            },
                            icon: _vm.bookedLoadMarkerPinIcon(
                              positionMarker.load,
                              positionMarker.spaceTimeOrder
                            ),
                            label: {
                              text: positionMarker.load.mapId,
                              color: "#FFFFFF"
                            },
                            clickable: true,
                            draggable: false
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit(
                                "selectBookedLoad",
                                positionMarker.load
                              )
                            },
                            mouseover: function($event) {
                              return _vm.toggleInfoWindow(
                                {
                                  lat: positionMarker.lat,
                                  lng: positionMarker.lng
                                },
                                positionMarker.infoText
                              )
                            }
                          }
                        })
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.plannedLoadPositionMarkers, function(
                    positionMarker,
                    idx
                  ) {
                    return _vm.plannedLoadPositionMarkers
                      ? _c("GmapMarker", {
                          key: "planned_load_markerId_" + idx,
                          attrs: {
                            position: {
                              lat: positionMarker.lat,
                              lng: positionMarker.lng
                            },
                            icon: _vm.plannedLoadMarkerPinIcon(
                              positionMarker.load,
                              positionMarker.spaceTimeOrder
                            ),
                            clickable: true,
                            draggable: false
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit(
                                "selectPlannedLoad",
                                positionMarker.load
                              )
                            },
                            mouseover: function($event) {
                              return _vm.toggleInfoWindow(
                                {
                                  lat: positionMarker.lat,
                                  lng: positionMarker.lng
                                },
                                positionMarker.infoText
                              )
                            }
                          }
                        })
                      : _vm._e()
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "pt-2", attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm10: "", "pr-2": "" } },
                [
                  _c(
                    "v-slider",
                    {
                      attrs: {
                        min: "0",
                        max: _vm.spaceTimeSliderMaxValue,
                        ticks: "always",
                        "tick-size": "1",
                        step: "1",
                        "thumb-label": "always",
                        color: _vm.currentColor,
                        trackColor: _vm.timeMachineTrackColor,
                        thumbColor: _vm.currentColor,
                        "always-dirty": "",
                        hint: _vm.currentFutureDay,
                        "persistent-hint": "",
                        "inverted-label": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "thumb-label",
                          fn: function(props) {
                            return [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v("\n              watch\n            ")
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.sliderValue,
                        callback: function($$v) {
                          _vm.sliderValue = $$v
                        },
                        expression: "sliderValue"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "prepend" },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-img", {
                                attrs: {
                                  src: "/static/time-machine.png",
                                  height: "50"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { sm2: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      outline: "",
                      height: "12",
                      dense: "",
                      "full-width": false,
                      label: "Days into Future",
                      items: _vm.daysIntoFutureOptions
                    },
                    model: {
                      value: _vm.daysIntoFuture,
                      callback: function($$v) {
                        _vm.daysIntoFuture = $$v
                      },
                      expression: "daysIntoFuture"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-320db361", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-320db361","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidgets/SpaceTimeContinuum.vue
// module id = null
// module chunks = 